import React, {CSSProperties, useEffect} from "react";
import {observer} from "mobx-react";
import styled from "styled-components";
import {useServices} from "../../hooks/use-services.hook";
import {CmsPageKey} from "../../services/cms/cms.service.interface";
import {Check} from "../../types/type-checking";
import {NullableNumber} from "../../types/nullable-types";


const IframeBox = styled.iframe`
    width: 100%;
    border: none;
    min-height: 100vh;
`

/*<iframe sandbox="allow-scripts allow-top-navigation allow-pointer-lock allow-same-origin allow-popups" onload="$(this).contents().find('a').on('click', function(e) {e.preventDefault(); var url = e.target.href; window.open(url, '_system', 'location=yes'); });"></iframe>*/

interface CmsPageComponentProps {
    useUrl?: string;
    useParams?: {
        pageKey: CmsPageKey;
        urlBuilderParams?: Record<string, string>;
    },
    className?: string;


}
export const CmsPageComponent: React.FC<CmsPageComponentProps> = observer((props) => {
    const services = useServices();
    const [iframeHeight, setIframeHeight] = React.useState<NullableNumber>(null);

    useEffect(() => {

        const handler = (event: MessageEvent) => {
            if(event.data?.type === 'CMS_DOCUMENT_HEIGHT') {
                const height = parseInt(event.data.height);
                if(Check.isNumber(height)) {
                    setIframeHeight(height);
                }
            }
        }

        window.addEventListener('message', handler)

        return () => {
            window.removeEventListener('message', handler);
        }
    }, []);

    let url = props.useUrl;
    if(!url && props.useParams) {
        url = services.cms.getPageUrl(props.useParams.pageKey, props.useParams.urlBuilderParams);
    }

    if(!url) {
        services.logger.error('No parameters provided for CmsPageComponent');
        return null;
    }

    const frameStyles: CSSProperties = {}

    if(!Check.isNullOrUndefined(iframeHeight)) {
        frameStyles.height = `${iframeHeight}px`;
    }

    return (
        <IframeBox style={frameStyles} className={props.className} src={url}/>
    );
});
